import React from 'react'
import { Form, Formik } from 'formik'

import Input from '../../components/common/Input'
import { required } from '../../utils/validators'
import Button from '../../components/common/Button'
import Select from '../../components/common/Select'
import { payment, paymentTypeOptions } from '../../utils/types'
import { useLoad } from '../../hooks/request'
import { BUILDING_CATEGORY_LIST } from '../../urls'

export default function BuildingExpenseForm({ onCancel, onSubmit, loading, initialValues }) {
    // Fetch categories
    const { response: categoryResponse } = useLoad({ url: BUILDING_CATEGORY_LIST, params: { size: 1000 } })
    const categoryItems = categoryResponse ? categoryResponse.results : []
    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={{
                status: '',
                note: '',
                amount: '',
                category: '',
                paymentType: '', // Default to naqd
                ...initialValues,
            }}
        >
            {({ setFieldValue }) => (
                <Form>
                    <div className="columns">
                        <div className="column">
                            <Select optionValue="value" optionLabel="name" name="status" label="Тип расхода" options={payment} disabled={loading} />
                            <Select
                                empty
                                name="category"
                                options={categoryItems.filter((item) => item.parent === null)}
                                onChange={(e) => {
                                    const selectedCategoryId = e.target.value
                                    setFieldValue('category', selectedCategoryId)
                                }}
                                label="Категория"
                                disabled={loading}
                            />

                            <Select optionValue="value" optionLabel="name" name="paymentType" label="То'лов тури" options={paymentTypeOptions} disabled={loading} />

                            <Input name="amount" type="number" label="Цена поступление" validate={required} disabled={loading} />
                            <Input component="textarea" name="comment" label="Примечание" validate={required} disabled={loading} />
                        </div>
                    </div>

                    {/* Buttons */}
                    <div style={{ gap: 5 }} className="buttons is-flex is-justify-content-space-between mt-4">
                        <div className="button-wrapper">
                            <Button onClick={onCancel} icon="close-outline" text="Ёпиш" className="is-danger" />
                        </div>
                        <div className="button-wrapper">
                            <Button loading={loading} text="Сақлаш" icon="add-outline" type="submit" className="is-success" />
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    )
}
